import moment from 'moment';
import { Modal } from 'bootstrap';
import { setDataAndShowDetailsModal } from 'static/components/details-modal/details-modal';
import { AdminEvent } from 'static/classes/Event';

export function AllUpcomingEventsViewModel(data){

   // console.log(data);

    var self = this;
    self.type = "AllUpcomingEventsViewModel";

    self.rootvm = data.rootvm;

    self.initialized = ko.observable(false);
    self.initialize = function(){

        //console.log('initing all upcoming_events vm');

        if (!self.initialized()){
            self.lookup_upcoming_events();
        }
        if (self.offset() == undefined){
            self.offset(0);
        }
        if (self.limit() == undefined){
            self.limit(30);
        }
    };

    self.total_count = ko.observable();
    self.filtered_count = ko.observable();
    self.offset = ko.observable();
    self.limit = ko.observable();

    self.upcoming_events = ko.observableArray([]);

    self.error = ko.observable();
    self.search_name = ko.observable();

    self.show_gift_box_requests = ko.observable();

    self.search_name_click = function(){
        self.offset(0);
        console.log('searching with ', self.search_name());
        self.lookup_upcoming_events();
        return false;
    }

    self.set_search_filter = function(search){
        self.search_name(search);
        self.search_name_click();
    }


    self.lookup_upcoming_events = function(){
        self.rootvm.is_busy(true);
        return $.ajax({

            url: self.rootvm.web_host + '/api/admin/upcoming-events',
            type: 'GET',
            data:{
                limit: self.limit(),
                offset: self.offset(),
                search_name: self.search_name(),
                show_gift_box_requests:self.show_gift_box_requests()
            },

            contentType: "application/json; charset=utf-8",

            success: function (data) {

                self.upcoming_events(ko.utils.arrayMap( data.events || [],
                    function(x){
                        x.rootvm = self.rootvm
                        return new AdminEvent(x);
                    }));

                self.total_count(data.total_count);
                self.filtered_count(data.total_count);
            },
            error: function (data) {
                notyf.error(data.statusText);
            },
            complete: function(){
                self.rootvm.is_busy(false);
            }
        });
    };

    // Everything below is for paging -- should really create a
    // component at some point

    self.lower_count_label = ko.computed(function(){
        return parseInt(self.offset()) + 1;
    });

    self.upper_count_label = ko.computed(function(){
        if (parseInt(self.limit()) + parseInt(self.offset()) > self.filtered_count())
        {
            return self.filtered_count();
        }
        else
        {
            return parseInt(self.limit()) + parseInt(self.offset());
        }
    });



    self.paging_visible = ko.computed(function () {
        return self.total_count() > 0;
    });

    self.next_button_visible = ko.computed(function() {
        return parseInt(self.offset()) + parseInt(self.limit()) < self.filtered_count();
    });

    self.previous_button_visible = ko.computed(function () {
        return parseInt(self.offset()) > 0;
    });



    self.go_left = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) - parseInt(self.limit()));

        self.lookup_upcoming_events().then(function(){
            pager.navigate("#concerts/upcoming"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
        });
    };

    self.go_right = function () {

        if (self.rootvm.is_busy()){
            return false;}

        self.offset(parseInt(self.offset()) + parseInt(self.limit()));
        self.lookup_upcoming_events().then(function(){
            pager.navigate("#concerts/upcoming"
                + "?offset="
                + self.offset()
                + "&limit="
                + self.limit()
            );
           });
    };

    self.new_confirmed_event_date = ko.observable(new moment());
    self.selected_event = ko.observable();

    self.show_change_date = function(sc_event){
        self.new_confirmed_event_date(sc_event._confirmed_event_date_moment()._i);
        self.selected_event(sc_event);
        const changeDateModal = document.getElementById('changeDateModal');
        Modal.getOrCreateInstance(changeDateModal).show();
    };

    self.save_changed_date = function(){

        return $.ajax({
            url: "/api/admin/event/change-confirmed-date",
            type: "POST",
            contentType: "application/json; charset=utf-8",
            processData: false,

            data: ko.toJSON({
                event_uuid:  self.selected_event().event_uuid(),
                new_confirmed_event_date: self.new_confirmed_event_date()
            }),

            complete: function (data) {
                self.rootvm.is_busy(false);
            },

            success: function (data) {
                if (data.success) {
                    data.sc_event.rootvm = self.rootvm;
                    var e = ko.utils.arrayFirst(self.upcoming_events(), function(item){
                        return item.event_uuid() == self.selected_event().event_uuid()
                    })

                    e._confirmed_event_date_moment(new moment(data.sc_event.confirmed_event_date));
                    e.confirmed_event_date(new moment(data.sc_event.confirmed_event_date).format('ddd DD.MM.YY'));

                    notyf.success(data.message);
                    const changeDateModal = document.getElementById('changeDateModal');
                    Modal.getOrCreateInstance(changeDateModal).hide();
                }
                else {
                    notyf.error(data.message);
                }
            },
            statusCode:{
                500 : function(){
                    notyf.error('Server error! Find Rob!')
                }
            }

       });
    }

    self.set_selected_data = (event, tabId) => {
        setDataAndShowDetailsModal(event, tabId);
    }
};
